import React from 'react'
import { Button, useTheme } from 'react-native-paper'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'
import { Container, TextBodySecondary } from '../atoms'

/**
 *
 * @param props
 * @param { string } props.label
 * @param props.style
 * @param { number } props.height - To set height for content, button, and container.
 * @param props.children
 * @param { function } props.onPress
 * @returns {JSX.Element}
 * @constructor
 */
export const ButtonOutlined = ({ label, style, children, height = 48, ...props }) => {
  const { colors } = useTheme()

  return <Button mode='outlined' uppercase={false} style={composeStyle({
    borderColor: colors.borderLight,
    borderRadius: 4,
    minWidth: undefined,
    height
  }, style)} contentStyle={{ height }} {...props}>
    <Container center row style={{ height }}>
      {label && <TextBodySecondary noTopMargin>{label}</TextBodySecondary>}
      {children}
    </Container>
  </Button>
}
